export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/calendar-events', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/calendar-event', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/calendar-event/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/calendar-event/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/calendar-event/' + data.id, { params: data.filters || {} })
  }
})
